import React from "react";

import { getOnboardingPath, PROFILE_COMPLETE } from "../../../constants";

import Button from "../../../components/formElements/button/Button";

import * as actions from "../../../store/actions";
import { connect } from "react-redux";

const ProfileComplete = ({ history, authInit }) => {
  return (
    <div className="container text-center" style={{ maxWidth: 550 }}>
      <p className="header mb-5" style={{ fontSize: 20 }}>
        <span className="change-primary-color mx-auto">
          Yay! You have successfully
          <br /> created your profile!
        </span>
      </p>
      <img src={PROFILE_COMPLETE} alt="" />
      <p className="change-primary-color">Let’s create your profile</p>
      <p>
        Your profile is under review. You can always edit your personal
        information and preferences in settings.
      </p>
      <Button
        className="w-75 mb-3"
        label="Get Started"
        onClick={() => {
          history.push(getOnboardingPath("/under-review"));
        }}
      />
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  authRedirect: () => dispatch(actions.authRedirect()),
  authInit: (path, loginRedirect) =>
    dispatch(actions.authInit(path, loginRedirect)),
});

export default connect(undefined, mapDispatchToProps)(ProfileComplete);
